<template>
  <!-- 二次确认弹窗（像删除） -->
  <RxkDialog
    :title="warnTipInfo.title"
    :width="warnTipInfo.width"
    v-model="visible"
    :cancelBtn="warnTipInfo.cancelButtonText"
    :showCancelBtn="warnTipInfo.cancelButtonState"
    :showConfirmBtn="warnTipInfo.sureButtonState"
    :confirmBtn="warnTipInfo.sureButtonText"
    @sure="handleConfirmBtn"
    @close="handleCancelBtn"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    align-center
    class="authentication-prompt-dialog"
    v-bind="$attrs"
  >
    <div class="texts authentication-prompt-content">
      <img class="warn-icon" :src="warnTipInfoIcon" />
      <div class="main-content">
        <p class="main-text">
          {{ warnTipInfo.mainContent }}
        </p>
        <p class="desc-text">{{ warnTipInfo.descContent }}</p>
      </div>
      <!-- 自定义内容 -->
      <template slot="customContent">
        <slot name="customContent" />
      </template>
    </div>
  </RxkDialog>
</template>

<script>
import { RxkDialog } from '@/components/common/RxkDialog'
export default {
  name: 'warnTipDialog',
  components: { RxkDialog },
  props: {
    showWarnTip: {
      type: Boolean,
      default: false
    },
    // 提示内容
    warnTipInfo: {
      type: Object,
      default: () => {
        return {
          title: '',
          cancelButtonText: '取消',
          sureButtonText: '确定',
          cancelButtonState: false, // 是否显示取消按钮，false显示 true 不显示
          sureButtonState: false, // 同上
          // type: 1, // 标识
          descContent: '',
          mainContent: '',
          icon: '',
          width: '410px',
          type: 'warn' // icon的优先级高于type
        }
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    visible: {
      get() {
        return this.showWarnTip
      },
      set(v) {
        this.$emit('update:showWarnTip', v)
      }
    },
    warnTipInfoIcon() {
      const { icon = '', type = 'warn' } = this.warnTipInfo
      // icon的优先级高于type
      if (!icon) {
        const typeIconMap = {
          // 目前就两种，可根据业务拓展
          warn: new URL('@/assets/importFiles/tips_icon@2x.png', import.meta.url).href,
          success: new URL('@/assets/importFiles/success-icon.jpg', import.meta.url).href
        }
        return typeIconMap[type]
      }
      return icon
    }
  },
  methods: {
    handleConfirmBtn(fn) {
      this.$emit('handleConfirmBtn', fn)
    },
    handleCancelBtn() {
      this.$emit('handleCancelBtn')
    }
  }
}
</script>

<style lang="scss" scoped>
.authentication-prompt-dialog {
  .el-dialog__header {
    padding: 0 24px;
    .el-dialog__headerbtn {
      right: 24px;
      top: 4px;
    }
    .el-dialog__title {
      font-weight: 400;
      font-family: 'Microsoft YaHei';
      line-height: 24px;
    }
  }
  .authentication-prompt-content {
    display: flex;
    padding: 24px 24px 17px;
    align-items: center;
    .warn-icon {
      width: 16px;
      height: 16px;
      margin-right: 8px;
      margin-top: 2px;
    }
    .main-content {
      margin-left: 8px;
      .main-text {
        color: #333333;
        font-size: 14px;
        font-family: 'Microsoft YaHei';
        text-align: left;
        letter-spacing: 0.7px;
        line-height: 22px;
      }
      .desc-text {
        color: #999999;
        font-size: 14px;
        font-weight: 400;
        font-family: 'Microsoft YaHei';
        line-height: 20px;
        letter-spacing: 0.7px;
        margin-top: 9px;
      }
    }
  }
  .el-dialog__footer {
    border: none;
    padding-right: 24px;
    .el-button + .el-button {
      margin-left: 8px;
    }
  }
}
</style>
